<script>
import BasicInput from "../../../../theme/atoms/BasicInput.vue";
import BasicButton from "../../../../theme/atoms/BasicButton.vue";
import {currentLocale} from "../../../../services/LocaleServices";
import LoginFormCandidate from "../../atoms/FormCandidate.vue";
import Button from "../../../../theme/atoms/BasicButton.vue";
import Messages from "../../atoms/Messages.vue";

export default {
    name: "ForgotPasswordForm",
    props: {
        candidate: {
            type: Object,
            required: false
        },
        errors: {
            type: Array,
            required: false
        },
        message: {
            type: String,
            required: false
        }
    },
    components: {
        Button,
        Messages,
        LoginFormCandidate,
        BasicInput,
        BasicButton,
    },
    data() {
        return {
            identifier: null,
            password: null,
            submitting: false,
            submittingForgot: false,
            loginErrors: this.errors
        }
    },

    methods: {
        setCsrfToken() {
            this.$refs.csrfTokenInput.value =  document.querySelector('meta[name="csrf-token"]').getAttribute('content');
        },
        handleSubmit() {
            this.submitting = true;
        },
    },
    mounted() {
        this.setCsrfToken();
    }
}
</script>

<template>
    <form class="d-flex flex-column gap-3 w-100" action="/auth/find-forgot-password" method="post" autocomplete="off" @submit="handleSubmit">
        <messages v-if="loginErrors" :messages="loginErrors"/>
        <messages v-if="message" alert-class="alert-success" :messages="[message]"/>

        <basic-input required autocomplete="new-identifier" name="identifier" left-icon="fi-rr-user" :label="trans('general.page.login.username')" v-model="identifier"/>
        <input type="hidden" name="_token" ref="csrfTokenInput">

        <basic-button class="btn-primary btn-100" :loading="submitting" type="submit" :text="trans('general.page.forgot_password.request_reset')"/>
    </form>
</template>

<style scoped>
.btn-100 {
    min-width: 100%;
}
</style>
